import script from "./FilterBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterBox.vue?vue&type=script&lang=ts&setup=true"

import "./FilterBox.vue?vue&type=style&index=0&id=3debd896&lang=scss&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3debd896"]])

export default __exports__